import { StreamActions, renderStreamMessage } from "@hotwired/turbo"

// Custom <turbo-stream action="counts"> — broadcast to the live ticket-index streams
// whenever queue counts change. Re-fetches /reload_counts, rendered in THIS user's UI
// variant: the new-UI response is a set of <turbo-stream> tags (sidebar nav + index tab
// counts) piped through renderStreamMessage; the classic response is plain HTML swapped
// into #leftnav.
StreamActions.counts = function() {
  fetch('/reload_counts')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then(data => {
      if (data.includes('<turbo-stream')) {
        renderStreamMessage(data);
        return;
      }
      const leftnav = document.getElementById('leftnav');
      if (leftnav) leftnav.innerHTML = data;
    })
    .catch(error => {
      console.error('There was a problem with the fetch operation:', error);
  });
}
